import React, { useMemo } from "react";
import { Table } from "antd";

// Status code mapping based on API response
const STATUS_MAP = {
  1: "Pending",
  2: "Assigned",
  3: "In Progress",
  4: "Under Review",
  5: "Delayed",
  6: "Completed",
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const getStatusBadge = (statusCode) => {
  const statusText = STATUS_MAP[statusCode] || "Unknown";

  const config = {
    Completed: {
      backgroundColor: "rgba(34, 197, 94, 0.1)",
      color: "#22c55e",
      border: "1px solid rgba(34, 197, 94, 0.2)",
    },
    "In Progress": {
      backgroundColor: "rgba(245, 158, 11, 0.1)",
      color: "#f59e0b",
      border: "1px solid rgba(245, 158, 11, 0.2)",
    },
    Delayed: {
      backgroundColor: "rgba(239, 68, 68, 0.1)",
      color: "#ef4444",
      border: "1px solid rgba(239, 68, 68, 0.2)",
    },
    Pending: {
      backgroundColor: "rgba(107, 114, 128, 0.1)",
      color: "#6b7280",
      border: "1px solid rgba(107, 114, 128, 0.2)",
    },
    Assigned: {
      backgroundColor: "rgba(59, 130, 246, 0.1)",
      color: "#3b82f6",
      border: "1px solid rgba(59, 130, 246, 0.2)",
    },
    "Under Review": {
      backgroundColor: "rgba(139, 92, 246, 0.1)",
      color: "#8b5cf6",
      border: "1px solid rgba(139, 92, 246, 0.2)",
    },
  };

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: "9999px",
        fontSize: "12px",
        fontWeight: "500",
        ...(config[statusText] || config.Pending),
      }}
    >
      {statusText}
    </span>
  );
};

const columns = [
  {
    title: "Key",
    dataIndex: "key",
    key: "key",
    width: 120,
    render: (text) => (
      <span style={{ fontWeight: "500", color: "#6b7280" }}>{text}</span>
    ),
  },
  {
    title: "Task Name",
    dataIndex: "task_name",
    key: "task_name",
    ellipsis: true,
    render: (text) => <span style={{ fontWeight: "500" }}>{text}</span>,
  },
  {
    title: "Assigned To",
    dataIndex: "assigned_to",
    key: "assigned_to",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => getStatusBadge(status),
  },
  {
    title: "Words",
    dataIndex: "words",
    key: "words",
    render: (words) => (
      <span style={{ fontWeight: "500" }}>
        {words != null ? words.toLocaleString() : "-"}
      </span>
    ),
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    key: "deadline",
    render: (deadline) => (
      <span style={{ color: "#6b7280" }}>{formatDate(deadline)}</span>
    ),
  },
  {
    title: "Created",
    dataIndex: "created",
    key: "created",
    render: (date) => (
      <span style={{ color: "#6b7280" }}>{formatDate(date)}</span>
    ),
  },
];

const TaskTable = ({ data = [] }) => {
  const tableData = useMemo(() => {
    return data.map((item, index) => ({
      ...item,
      key: item.key || index,
    }));
  }, [data]);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "16px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <h3
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "16px",
        }}
      >
        Task List
      </h3>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} tasks`,
        }}
        scroll={{ x: 900 }}
      />
    </div>
  );
};

export default TaskTable;
